import React, { useState } from 'react'
import { ButtonToolbar, Col, FlexboxGrid, Icon, IconButton, Panel, Row, Table, Uploader } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import { Controller, useForm } from 'react-hook-form'
import notification from '../../utils/notification'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { cloneDeep, isEmpty } from 'lodash-es'
import { DEFAULT_ERR_MSG, SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { exportAssessmentReport, getImportNodePage, processImportNode, saveImportNode, searchAssessmentReport } from '../../redux/actions/assessment'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import { downloadFile } from '../../utils/fileUtil'
import moment from 'moment'
import { DATE_TIME_FORMAT } from '../../constants/date'
import InputDateForm from '../../components/forms/input/InputDateForm'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import classNames from 'classnames'
import AppContext from '../../context/AppContext'
import ImportNodePreviewDataTable from './ImportNodePreviewDataTable'
import { doneLoading, startLoading } from '../../utils/loading'
import { downloadFileByPath } from '../../redux/actions/infomaDocument'

export default function ImportNodeDataWidgets({ schema: _schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const { theme } = React.useContext(AppContext)

  const [formSchema, setFormSchema] = useState(_schema)
  const [datas, setData] = useState(_schema?.resultData?.values || [])
  const [totalSize, setTotalSize] = useState(_schema?.resultData?.total || 0)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const [isFileImport, setIsFileImport] = useState(true)
  const [request, setRequest] = useState({
    pageNum: 1,
    pageSize: displayLength,
  })

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleSearch = async (page, size) => {
    setIsLoading(true)
    try {
      // console.log('req : ', req)

      const response = await getImportNodePage(page, size)

      // console.log('response ', response)

      if (response) {
        setData(response?.resultData?.values || [])
        setTotalSize(response?.resultData?.total || 0)

        // onRefash()
      } else {
        setData([])
        setTotalSize(0)
        // onRefash()
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey) 
    handleSearch(dataKey, displayLength)
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)

    handleSearch(1, dataKey)
  }

  const handleSubmitImportFile = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const file = getValues('fileImport')

      const formData = new FormData()
      file &&
        file?.forEach((element) => {
          formData.append(`File`, element.blobFile)
        })

      const response = await processImportNode(formData)

      if (response) {
        handleSearch(page, displayLength)
        setValue('fileImport', null)
        setIsFileImport(true)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
      })
      } else {
        setError(response?.errorMessage || DEFAULT_ERR_MSG)
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCancelImport = () => {
    alert('handleCancelImport')
  }

  const onDownload = async () => {
      startLoading()
      try {
        var file = await downloadFileByPath('/system-doc/node-template/Import-Node-Templete.xlsx')
        //  var file = []
  
        const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Import-Node-Templete')
        document.body.appendChild(link)
        link.click()
      } catch (e) {
        notification.open('error', {
          title: e?.response?.data?.errorMessage || 'ดาวน์โหลดไม่สำเร็จ',
        })
      }
      doneLoading()
    }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel
        bordered
        // key={data.id}
        style={{ marginBottom: 10, marginTop: 10 }}
        collapsible
        defaultExpanded
        header={formSchema.header}
        shaded
      >
        <IconButton
          appearance="ghost"
          icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
          onClick={(e) => onDownload()}
          disabled={isLoading}
        >
          ดาวน์โหลด Template
        </IconButton>
        
        <Row style={{ marginTop: 10 }}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Controller
              name={`fileImport`}
              control={control}
              defaultValue={''}
              render={(props) => {
                return (
                  <Uploader
                    draggable
                    accept={'.xlsx'}
                    autoUpload={false}
                    multiple={false}
                    fileList={props.value || []}
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                        setIsFileImport(true)
                      } else {
                        // props.onChange(fileList)

                        setIsFileImport(false)
                        let files = []
                        files.push(fileList[fileList.length - 1])
                        props.onChange(files)
                      }
                    }}
                  >
                    <div>
                      <div
                        style={{ lineHeight: '50px' }}
                        className={classNames('uploader', `${theme[0]}-background`)}
                      >
                        <Icon size="4x" icon="upload2" />
                        <small className="uploder__text">
                          <p style={{ wordBreak: 'break-word' }}>
                            คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                          </p>
                        </small>
                      </div>
                    </div>
                  </Uploader>
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 20 }}>
          {/* <hr /> */}
          <ButtonToolbar style={{ textAlign: 'right' }}>
            <SaveButton onClick={handleSubmitImportFile} disabled={isFileImport}>
              {'บันทึก'}
            </SaveButton>

            {/* <CancelButton
              onClick={() => {
                handleCancelImport()
              }}
            >
              {'ยกเลิก'}
            </CancelButton> */}
          </ButtonToolbar>
        </Row>

        {datas && (
          <>
          <ImportNodePreviewDataTable
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            schema={datas}
            // onCancel={handleCacel}
            // onSave={handleSave}
            // isViewMode={!formSchema?.form?.isEnableEdit}
            // onViewHistory={onViewHistory}
          />
          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total || 0} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        </>
        )}

        
      </Panel>
    </>
  )
}
